// extracted by mini-css-extract-plugin
export var actionsRow = "_r-a";
export var actionsRowEnd = "_r-b";
export var askRedoBlackBtn = "_r-d";
export var askRedoBlackBtnIcon = "_r-e";
export var exitModalActionBtn = "_r-c";
export var exitModalRoot = "_r-0";
export var followUpInput = "_r-9";
export var modalContentBody = "_r-7";
export var modalHeaderImage = "_r-2";
export var modalImageLabel = "_r-4";
export var modalImageOverlay = "_r-3";
export var modalImageSubheading = "_r-6";
export var modalImageTitle = "_r-5";
export var modalImageWrapper = "_r-1";
export var reasonCard = "_r-f";
export var reasonCardSelected = "_r-g";
export var reasonIcon = "_r-j";
export var reasonIconWrap = "_r-i";
export var reasonIndicator = "_r-l";
export var reasonIndicatorDot = "_r-n";
export var reasonIndicatorSelected = "_r-m";
export var reasonLabel = "_r-h";
export var reasonList = "_r-8";
export var reasonTitle = "_r-k";